registerComponent("blocks/card-blog", function (component) {
/**
 * Sem comportamento: o cartão é markup e LESS. O arquivo existe para o build
 * registrar o componente e marcar `data-initialized="true"` na raiz.
 */

});
